export default [
    {
        path: "/roroManifest/list",
        name: "RoRoManifestList",
        component: () => import("@/views/RoRoManifest/list"),
        hidden: true,
        meta: {
            title: "舱单列表",
            activeMenu: "/roroManifest/list",
            keepAlive: true,
        },
    },
    {
        path: "/roroManifest/rsn",
        name: "RoRoManifestRsn",
        component: () => import("@/views/ManifestMake/rsn"),
        hidden: true,
        meta: {
            title: "收发通",
            activeMenu: "/roroManifest/rsn",
        },
    },
    {
        path: "/roroManifest/mailAccount",
        name: "RoRoManifestMailAccount",
        component: () => import("@/views/ManifestMake/mailAccount"),
        hidden: true,
        meta: {
            title: "邮箱管理",
            activeMenu: "/roroManifest/mailAccount",
        },
    },
    {
        path: "/roroManifest/edit",
        name: "RoRoManifestEdit",
        component: () => import("@/views/RoRoManifest/edit.vue"),
        hidden: true,
        meta: {
            title: "滚装船舱单编辑",
            activeMenu: "/roroManifest/list",
        },
    },
];
